module.exports = __webpack_public_path__ + "img/slide-4-mob.21ca07c.webp";